export default __webpack_public_path__ + "static/media/credit-card.e24ee49e.svg";